import React from 'react';
import './App.css';
import FrontPage from './components/frontPage';

function App() {
  return (
    <div className="App">
      <FrontPage/>
    </div>


  );
}

export default App;